import { Divider } from '@neo4j-ndl/react';
import { type DbmsInfo } from '@nx/state/desktop';
import { isNotNullish } from '@nx/stdlib';
import { OpenPathIconButton } from '@nx/ui/src/open-path-button/open-path-button';
import { Fragment } from 'react/jsx-runtime';

import { PropertyDisplay } from '../property-display';

export const InstanceInfo = ({ instance }: { instance: Partial<DbmsInfo> }) => {
  return (
    <div className="flex flex-wrap items-center gap-2  py-3">
      {[
        isNotNullish(instance.id) ? (
          <PropertyDisplay key="id" label="ID" text={instance.id} truncate allowCopyText />
        ) : null,
        isNotNullish(instance.version) ? (
          <PropertyDisplay key="version" label="Version" text={instance.version} />
        ) : null,
        isNotNullish(instance.rootPath) ? (
          <PropertyDisplay
            key="path"
            label="Path"
            text={instance.rootPath}
            truncate
            action={<OpenPathIconButton path={instance.rootPath} size="small" />}
          />
        ) : null,
        isNotNullish(instance.connectionUri) && instance.connectionUri !== '' ? (
          <PropertyDisplay key="connectionUri" label="Connection URI" text={instance.connectionUri} allowCopyText />
        ) : null,
      ]
        .filter(Boolean)
        .map((item, i) => (
          <Fragment key={i}>
            {i !== 0 && <Divider orientation="vertical" />}
            {item}
          </Fragment>
        ))}
    </div>
  );
};
